import React, { ReactElement, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Box, Grid, TextField, Typography } from "@mui/material";
import {
  cranableTypes,
  customsDocumentTypes,
  unitTypes,
} from "../../../../const/types/editBookingTypes";
import { ReactHookFormSelect } from "../../../ReactHookFormSelect/ReactHookformSelect";

interface UnitIdFormProps {
  classes: {
    titlesBoxStyle: string;
    typography: string;
    textAndDropdownGrids: string;
    textField: string;
    formControl: string;
    inputLabelAndMenuItems: string;
  };
}

const UnitId: React.FC<UnitIdFormProps> = ({
  classes,
}: UnitIdFormProps): ReactElement => {
  const {
    register,
    control,
    formState: { errors },
    trigger,
    setValue,
  } = useFormContext();

  const isCranable = useWatch({ name: "isCranable" });

  useEffect(() => {
    if (!isCranable) {
      setValue("iluCode", "");
    }
  }, [isCranable, setValue]);

  return (
    <>
      <Box className={classes.titlesBoxStyle}>
        <Typography className={classes.typography} variant="h6">
          Unit Id
        </Typography>
      </Box>
      <Grid container spacing={3} className={classes.textAndDropdownGrids}>
        <Grid item xs={3}>
          <ReactHookFormSelect
            name={"unitType"}
            classes={classes}
            error={false}
            labelId="unitType-labelId"
            selectId="unitType-id"
            control={control}
            label="Unit Type"
            options={unitTypes}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            className={classes.textField}
            id="plateNumber"
            type="text"
            label="Plate Number"
            {...register("plateNumber")}
            error={Boolean(errors.plateNumber)}
            helperText={errors.plateNumber?.message?.toString() || ""}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            className={classes.textField}
            id="iluCode"
            type="text"
            label="ILU Code"
            {...register("iluCode")}
            error={Boolean(errors.iluCode)}
            helperText={errors.iluCode?.message?.toString() || ""}
            disabled={!isCranable}
          />
        </Grid>
        <Grid item xs={3}>
          <ReactHookFormSelect
            labelId="cranable-labelId"
            label="Cranable"
            options={cranableTypes}
            control={control}
            name={"isCranable"}
            classes={classes}
            selectId={"cranable-id"}
            error={false}
            trigger={() => {
              trigger(["iluCode"]);
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <TextField
            className={classes.textField}
            id="tareWeight"
            type="number"
            label="Tare Weight"
            {...register("tareWeight", { valueAsNumber: true })}
            error={Boolean(errors.tareWeight)}
            InputProps={{
              inputProps: { min: 0 },
            }}
            helperText={errors.tareWeight?.message?.toString() || ""}
          />
        </Grid>

        <Grid item xs={3}>
          <ReactHookFormSelect
            selectId="customsDocumentType-id"
            labelId="customsDocumentType-labelId"
            name={"customsDocumentType"}
            control={control}
            label="Customs Document Type"
            options={customsDocumentTypes}
            classes={classes}
            error={Boolean(errors.customsDocumentType)}
          />
        </Grid>

        <Grid item xs={3}>
          <TextField
            className={classes.textField}
            id="netWeight"
            type="number"
            InputProps={{
              inputProps: { min: 0 },
            }}
            label="Net Weight"
            {...register("netWeight", { valueAsNumber: true })}
            error={Boolean(errors.netWeight)}
            helperText={errors.netWeight?.message?.toString() || ""}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default UnitId;
